import React, { useState } from 'react';

import { Agreement } from '../../../../../../../api-client/models/documents/Agreement';
import documentIcon from '../../../../../../../assets/images/svg/document.svg';
import { Button, Image, Loader } from '../../../../../../../components';
import FileSize from '../../../../../../../components/common/utils/FileSize/FileSize';
import apiClientConfig from '../../../../../../../configs/app';
import { createAgreementProvider } from '../../../../../../../di';
import { formatDate } from '../../../../../../../formatters';
import { useErrorCallback } from '../../../../../../../hooks';
import styles from '../DocumentsToProjectsItem.module.scss';

interface Props {
  document: Agreement;
}

export const RightToClaim = ({ document }: Props) => {
  const [loading, setLoading] = useState(false);
  const handleError = useErrorCallback();

  const downloadAgentReport = async (investUuid?: string) => {
    setLoading(true);
    try {
      const provider = await createAgreementProvider();
      if (investUuid) {
        const result = await provider.createAgentReport(investUuid);
        window.open(apiClientConfig.apiBaseUrl + result.url, '_blank');
      }
    } catch (error) {
      if (error instanceof Error) {
        await handleError(error);
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <li key={document.uuid} className={styles.documentsToProjectBody__list}>
      <div className={styles.documentsToProjectBody__item}>
        <a
          className={styles.documentsToProjectBody__item}
          href={document.file.url}
          target="_blank"
          rel="noreferrer"
        >
          <Image className={styles.documentsToProjectBody__icon} src={documentIcon} />
          <div className={styles.documentsToProjectBody__title}>Приобретение права требования</div>
          <div className={styles.documentsToProjectBody__size}>
            pdf, <FileSize file={document.file} />
          </div>
          <div className={styles.documentsToProjectBody__watch}>Нажмите, чтобы посмотреть</div>
          <div className={styles.documentsToProjectBody__date}>
            {formatDate(document.createdAt)}
          </div>
          <div className={styles.documentsToProjectBody__dateText}>дата подписания</div>
        </a>
        <div className={styles.documentsToProjectBody__makeReport}>
          <Button
            className={styles.documentsToProjectBody__orderReport}
            onClick={() =>
              downloadAgentReport(
                document.tags.find((tag) => tag.objectType === 'investment')?.objectUuid
              )
            }
          >
            заказать текущий отчет агента
          </Button>
          {loading && <Loader />}
        </div>
      </div>
    </li>
  );
};
